import { PageHeader } from 'components/PageHeader';
import { ErrorFallbackScreen } from 'components/screens';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { NotificationSettings } from 'modules/push-notification';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const NotificationSettingsPage = () => {
  const { isEnabled: isPushEnabled, isLoading } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_IS_PUSH_ENABLED
  );

  if (isLoading) return null;

  if (!isPushEnabled) {
    return <ErrorFallbackScreen />;
  }

  return (
    <Layout
      header={
        <PageHeader
          title={getTrans('profilePage.linkLabel.notificationSettings')}
          withBackBtn
        />
      }
    >
      <NotificationSettings />
    </Layout>
  );
};
